import fetch from 'services/request';
import { TimeFilter } from './types';

const API_V1 = '/api/v1';
const REPORT_BASE_URL = API_V1 + '/report';
const STAFF_BASE_URL = API_V1 + '/staff';
const homeApis = {
  report: {
    getCashDeposit: (params: {endDate: string, startDate: string}) => 
      fetch({
        method: 'get',
        url: `${REPORT_BASE_URL}/cash-deposit`,
        params
      }) ,
    getSummary: (params: {endDate: string, startDate: string}) =>
      fetch({
        method: 'get',
        url: `${REPORT_BASE_URL}/summary`,
        params
      }),
    getPaymentType: (params: {startDate: string, endDate: string}) =>
      fetch({
        method: 'get',
        url: `${REPORT_BASE_URL}/summary-chart-payment-type`,
        params
      }),
    getSummaryChart: (params: {type: TimeFilter}) => 
      fetch({
        method: 'get',
        url: `${REPORT_BASE_URL}/summary-chart`,
        params
      })
  },
  staff: {
    getAll: () =>
      fetch({
        method: 'get',
        url: `${STAFF_BASE_URL}/all`,
      }),
    getClockTime: () =>
      fetch({
        method: 'get',
        url: `${STAFF_BASE_URL}/clock-time`
      }),
    checkIn: (body: { passcode: string }, staffId: string) =>
      fetch({
        method: 'post',
        url: `${STAFF_BASE_URL}/clock-in/${staffId}`,
        body
      }),
    checkOut: (body: { passcode: string }, staffId: string) =>
      fetch({
        method: 'post',
        url: `${STAFF_BASE_URL}/clock-out/${staffId}`,
        body
      })
  }
};

export default homeApis;
